<template >
    <div class="lab-btns">
        <template v-for="menu in menus">
            <el-button size="mini" plain :type="menu.css==''?'primary':menu.css" :icon="getMenuIcon(menu.name)" @click="handleclick(menu.linkurl, index, row)" :key="menu.id" v-if="ignore_ids.indexOf(','+menu.id+',')<0">
                {{menu.name}}
            </el-button>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        row: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default(){
                return 0
            }
        },
        menus: {
            type: Array,
            default(){
                return []
            }
        },
        ignore_ids: {
            type: String,
            default() {
                return ''
            }
        }
    },
    methods: {
        getMenuIcon(name) {
            if (!name) return ''
            if (name.indexOf('查看') >= 0) return 'el-icon-search'
            if (name.indexOf('编辑') >= 0) return 'el-icon-edit'
            if (name.indexOf('下载') >= 0) return 'el-icon-download'
            if (name.indexOf('删除') >= 0) return 'el-icon-delete'
            if (name.indexOf('附件') >= 0) return 'el-icon-paperclip'
            if (name.indexOf('借调') >= 0) return 'el-icon-refresh'
            if (name.indexOf('设置') >= 0) return 'el-icon-setting'
            if (name.indexOf('处置') >= 0) return 'el-icon-finished'
            return ''
        },
        handleclick(func, index, row){
            this.$emit('on_btnclk',{func: func, index: index, row: row});
        },
    }
}
</script>

<style lang="less" scoped>
.lab-btns {
    /deep/ .el-button [class*="el-icon-"] + span {
        margin-left: 1px !important;
    }
    /deep/ .el-button [class*="el-icon-"] {
        margin-right: 0;
    }
}
</style>